import { getCiTokenCtor, axiosInstance as instance } from '@/lib/auth/login.js'

export default {
  state: {
    ciToken: '',
    loading: true,
  },
  getters: {
    ci(state) {
      return state;
    },
    isLoadingToken(state) {
      return state.loading;
    },
    ciToken(state) {
      return state.ciToken;
    },
  },
  mutations: {
    updateCi(state, ci) {
      Object.assign(state, ci);
    },
    setLoadingToken(state, loading) {
      state.loading = loading;
    },
    updateToken(state, ciToken) {
      state.ciToken = ciToken;
    },
  },
  actions: {
    updateCi({ commit }, ci) {
      commit('updateCi', ci);
    },
    updateToken({ commit }, ciToken) {
      commit('updateToken', ciToken);
    },
    async fetchCiToken({ commit, rootGetters }) {
      commit('setLoadingToken', true);
      const oktaAccessToken = rootGetters?.default?.oktaAccessToken || null;
      const axiosInstance = instance(oktaAccessToken);
      const getCiToken = getCiTokenCtor({ axiosInstance });
      try {
        const result = await getCiToken();
        commit('updateToken', result.data.token.token);
        commit('setLoadingToken', false);
        return token.token;
      } catch(e) {
        commit('setLoadingToken', false);
        return Promise.reject(false);
      }
    },
  },
};